import relic from './consecutiveSignIn/relic';

export default {
    name: 'consecutiveSignIn',
    relic,
};
